export class TeamResultMonth
{
    constructor(month)
    {
        this.Month = month;
    }
    
    Month = 0;
    // 売上
    Sales = 0;
    // 営業総益(仮)
    Prov_GrossOperatingProfit = 0;
    // ｸﾚｰﾑ調整
    ClaimAdjustment = 0;
    // 洗替実績
    WashedResult = 0;
    // 営業総益
    GrossOperatingProfit = 0;
    // 原価算入外経費
    NonCostExpenses = 0;
    // 準営業利益
    QuasiOperatingProfit = 0;
    // チーム共通費
    TeamCommonExpenses = 0;
    // 在庫ﾍﾟﾅﾙﾃｨ
    StockPenalty = 0;
    // 減価償却
    Depreciation = 0;
    // 営業利益
    OperatingProfit = 0;
    // 人件費
    StaffCost = 0;
    // 純利益
    NetIncome = 0;
    // 在庫
    Stock = 0;

    // For frontend only
    NetIncomeRate = 0;

    UpdateNetIncomeRate()
    {
        if (this.Sales !== 0)
        {
            this.NetIncomeRate = this.NetIncome / this.Sales;
        }
        else
        {
            this.NetIncomeRate = 0;
        }
    }
}